import React from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  ButtonsContainer,
  ButtonWithLoader,
  Paper,
  PaperTitle,
  FormWrapper,
  Col,
  InlineFormRow,
  RFFormInput,
  RFFormCheckbox,
  RFFormRadioGroup,
} from 'virtues-bootstrap';
import { compose } from 'ramda';
import { Field, FieldArray, reduxForm } from 'redux-form';
import { Link } from 'react-router-dom';
import { withTranslation } from 'react-i18next';

import { FORM_NAMES } from 'constants/forms';

import AdditionalForm from 'components/AddPatient/AdditionalForm';
import PhonesFieldArray from 'components/AddPatient/Phones';
import { FORM_VALUE_ENGLISH, FORM_VALUE_FRENCH } from 'constants/languages';
import validate from './validateEditedInfo';

import s from './styles.module.scss';

const EditPatientInformation = ({ pristine, patientId, dob, submitting, t, handleSubmit }) => (
  <form onSubmit={handleSubmit}>
    <Paper>
      <PaperTitle withBorder>{t('addPatient.editPatient')}</PaperTitle>
      <FormWrapper title={t('addPatient.patientInformation')}>
        <InlineFormRow label={t('addPatient.patientId')} labelRequired>
          <Col xs={7} className={s.printedText}>
            {patientId}
          </Col>
        </InlineFormRow>
        <InlineFormRow label={t('addPatient.language')} labelRequired>
          <Col xs={3}>
            <RFFormRadioGroup
              groupName="language"
              radioButtons={[
                { label: t('addPatient.english'), value: FORM_VALUE_ENGLISH },
                { label: t('addPatient.french'), value: FORM_VALUE_FRENCH },
              ]}
              inline
            />
          </Col>
        </InlineFormRow>
        <InlineFormRow label={t('addPatient.dob')} labelRequired>
          <Col xs={7} className={s.printedText}>
            {dob}
          </Col>
        </InlineFormRow>
        <InlineFormRow label={t('addPatient.firstName')} labelRequired>
          <Col xs={7}>
            <Field placeholder="John" component={RFFormInput} name="firstName" type="text" />
          </Col>
        </InlineFormRow>
        <InlineFormRow label={t('addPatient.lastName')} labelRequired>
          <Col xs={7}>
            <Field placeholder="Smith" component={RFFormInput} name="lastName" type="text" />
          </Col>
        </InlineFormRow>
        <InlineFormRow label={t('addPatient.phoneNumber')} labelRequired>
          <FieldArray name="patientPhone" component={PhonesFieldArray} />
        </InlineFormRow>
        <InlineFormRow label="">
          <Col xs={7}>
            <Field
              component={RFFormCheckbox}
              name="checkboxContactVia"
              label={t('addPatient.contactVia')}
              spaceLg
            />
          </Col>
        </InlineFormRow>
        <InlineFormRow label={t('addPatient.email')}>
          <Col xs={7}>
            <Field
              placeholder="johnsmith@email.com"
              component={RFFormInput}
              name="email"
              type="email"
            />
          </Col>
        </InlineFormRow>
        <InlineFormRow label="">
          <Col xs={7}>
            <Field
              component={RFFormCheckbox}
              name="checkboxRecieve"
              label={t('addPatient.recieveEmail')}
              spaceLg
            />
          </Col>
        </InlineFormRow>
      </FormWrapper>
      <AdditionalForm namePrefix="caregiver" title={t('addPatient.caregiverInformation')} />
      <AdditionalForm namePrefix="alternate" title={t('addPatient.alternateEmergency')} />
    </Paper>
    <ButtonsContainer>
      <Button component={Link} to={`/patient/${patientId}`} variant="link">
        {t('buttons.cancel')}
      </Button>
      <ButtonWithLoader disabled={pristine} loading={submitting}>
        {t('addPatient.saveChanges')}
      </ButtonWithLoader>
    </ButtonsContainer>
  </form>
);

EditPatientInformation.propTypes = {
  dob: PropTypes.string.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  pristine: PropTypes.bool.isRequired,
  patientId: PropTypes.string.isRequired,
  submitting: PropTypes.bool.isRequired,
  t: PropTypes.func.isRequired,
};

export default compose(
  withTranslation(),
  reduxForm({
    form: FORM_NAMES.editPatient,
    enableReinitialize: true,
    validate,
  }),
)(EditPatientInformation);
